import React, { FC, useEffect, useState } from 'react';
import { LocalStorageService } from '../../configuration';
import {
  getMembershipStatus,
  getPublicMembership,
  MembershipStatus,
} from '../../api/payment/membership.api';
import { formatMemberUntil } from '../../utils/membership';
import ButtonSecondary from '../button-refactor/button-secondary';
import JoinMembershipDialog from './join-membership-dialog';
import MemberBadge from './member-badge';

interface Props {
  creatorId: string;
  creatorName: string;
}

const JoinMembershipButton: FC<Props> = ({ creatorId, creatorName }) => {
  const isLogged = !!LocalStorageService.getItem('accessToken');
  const [enabled, setEnabled] = useState(false);
  const [status, setStatus] = useState<MembershipStatus | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    setEnabled(false);
    setStatus(null);
    getPublicMembership(creatorId)
      .then((p) => alive && setEnabled(!!p.enabled))
      .catch(() => alive && setEnabled(false));
    if (isLogged) {
      getMembershipStatus(creatorId)
        .then((s) => alive && setStatus(s))
        .catch(() => undefined);
    }
    return () => {
      alive = false;
    };
  }, [creatorId, isLogged]);

  if (!enabled) return null;

  const memberUntil =
    status?.isMember && status.expiresAt ? formatMemberUntil(status.expiresAt) : '';

  return (
    <>
      <ButtonSecondary
        className="!border-[#DEE0E6] dark:border-slate-700 px-3 sm:px-6 !h-9 sm:!h-10 !font-medium !text-[#18191E] !rounded !leading-6 !text-sm sm:!text-xl flex items-center gap-1"
        onClick={() => setOpen(true)}
      >
        {memberUntil ? (
          <>
            <MemberBadge size={18} />
            {`Hội viên · đến ${memberUntil}`}
          </>
        ) : (
          'Tham gia'
        )}
      </ButtonSecondary>
      <JoinMembershipDialog
        creatorId={creatorId}
        creatorName={creatorName}
        visible={open}
        onClose={() => setOpen(false)}
        onStatus={(s) => setStatus(s)}
        onJoined={(s) => {
          setStatus(s);
          setOpen(false);
        }}
      />
    </>
  );
};

export default JoinMembershipButton;
